export default __webpack_public_path__ + "static/media/ss-2.dcff0f71.jpg";